import generateDiagnosticReport from './generateDiagnosticReport';

export default function appendDiagnosticReportToMessage(message: string): string {
    return (
        // This indenting is done to preserve the formatting of the string without having to concatenate a new string on each line
        `${message}
<pre>
================================
${generateDiagnosticReport()}
</pre>`
    );
}
